import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['copyButton', 'checkIcon', 'buttonText'];

  static values = {
    linkUrl: String,
    copyLinkText: String,
    linkCopiedText: String,
    plainColorClass: String,
    copiedColorClass: String,
  };

  connect() {
    this.element.addEventListener('resetButtonState', this.resetButtonState);
  }

  copyLinkToClipboard = (event) => {
    event.preventDefault();

    const input = document.createElement('input');
    input.value = this.linkUrlValue;
    window.document.body.appendChild(input);
    input.select();
    window.document.execCommand('copy');
    window.document.body.removeChild(input);

    this.setButtonCopiedState();

    this.element.dispatchEvent(new CustomEvent('linkCopied', {
      detail: { url: this.linkUrlValue },
      bubbles: true,
    }));
  };

  setButtonCopiedState = () => {
    this.checkIconTarget.classList.remove('hidden');
    this.buttonTextTarget.innerHTML = this.linkCopiedTextValue;
    this.copyButtonTarget.classList.add(this.copiedColorClassValue);
    this.copyButtonTarget.classList.remove(this.plainColorClassValue);
  };

  resetButtonState = (event) => {
    if (event.detail.url !== this.linkUrlValue) {
      this.checkIconTarget.classList.add('hidden');
      this.buttonTextTarget.innerHTML = this.copyLinkTextValue;
      this.copyButtonTarget.classList.add(this.plainColorClassValue);
      this.copyButtonTarget.classList.remove(this.copiedColorClassValue);
    }
  };
}
